import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../config/imageConfig';
import CarouselBanner from './common/CarouselBanner';
import './Garden.css';

function Garden() {
  // 图片资源 - 使用全局配置处理URL
  const bannerImg = getImageUrl('https://images.unsplash.com/photo-1520302719023-bd213ff4a8b9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  
  // 杏林花园图片资源
  const gardenImages = {
    garden: require('../assets/xlhy/x1.png'),
    exotic: require('../assets/xlhy/x2.png'), 
    rainforest: require('../assets/xlhy/x3.png'),
    desert: require('../assets/xlhy/x4.png'),
    specimen: require('../assets/xlhy/x5.png'),
    outdoor: require('../assets/xlhy/x6.png')
  };

  return (
    <div>
      {/* Banner图 - 使用轮播图组件 */}
      <CarouselBanner 
        categoryNameEn="XLHY"
        defaultImage={bannerImg}
        defaultTitle="杏林花园"
        defaultSubtitle="庐山杏林中药植物研究所的自然与科学殿堂"
        className="garden-banner"
      />

        {/* 花园区域 */}
        <div className="garden-section">
          <div className="garden-item">
            <div className="garden-content">
              <h2>花园区域</h2>
              <p>杏林花园占地5000平方米，拥有1000多种药用植物和珍稀植物，是中国最大的药用植物专类园之一。园区分为多个主题区域，包括：四季药用植物展示区、珍稀濒危植物保育区、传统中药植物区、现代药用植物研究展示区等。游客可以通过精心设计的步道系统，了解不同种类药用植物的特性及其在中医药中的应用。</p>
              <Link to="/garden/map" className="garden-btn">查看详细地图</Link>
            </div>
            <div className="garden-image">
              <img src={gardenImages.garden} alt="花园区域" />
            </div>
          </div>

          <div className="garden-item "> {/* 第2项：奇花异卉馆 - 左图片，右文字 */}
            <div className="garden-image">
              <img src={gardenImages.exotic} alt="奇花异卉馆" />
            </div>
            <div className="garden-content">
              <h2>奇花异卉馆</h2>
              <p>奇花异卉馆外特殊，花型奇念、花色绚丽或气味与众不同的一类植物。山荷分园主于温室空间内的生境营造，其中展示全球较典型的珍奇植物450余种，食虫植物的捕蝇草、茅膏菜、瓶子草、火炬草，被誉为自然界的"新猎手"，可以不用土壤生长的凤梨；时形怪色多变的秋海棠属。</p>
              <Link to="/garden/module/exotic" className="garden-btn">了解详情</Link>
            </div>
          </div>

          <div className="garden-item"> {/* 第3项：热带雨林馆 - 左文字，右图片 */}
            <div className="garden-content">
              <h2>热带雨林馆</h2>
              <p>热带雨林馆，共收集保育全球热带雨林植物1300余种，主要展示全球雨林典型植物，呈现形态万千的雨林景观，划分为榕主题、沙漠合、空中花园、花卉合、天科是长期植物热带雨林从6个主题展区，展示热带雨林从林的天际及附生现象，突出空中花园、独木成林、气生根、支柱根、板根等各样的"根"。</p>
              <Link to="/garden/module/rainforest" className="garden-btn">了解详情</Link>
            </div>
            <div className="garden-image">
              <img src={gardenImages.rainforest} alt="热带雨林馆" />
            </div>
          </div>

          <div className="garden-item "> {/* 第4项：沙生植物馆 - 左图片，右文字 */}
            <div className="garden-image">
              <img src={gardenImages.desert} alt="沙生植物馆" />
            </div>
            <div className="garden-content">
              <h2>沙生植物馆</h2>
              <p>沙生植物馆，共收集保育各类沙生植物400种。通过营造沙漠千旱气候，营造蜘蛛、岩层、砂质、砂质环境，以典型群落化方式展示来自非洲、美洲的沙生植物，以沙漠里的大树和花为主题，营造"都市绿洲"的沙漠森林和"花卉世界"，以沙漠植物领奇多变的形态，均匀各目的花朵、超强的生命力展现带有沙漠的气候和环境的印记。</p>
              <Link to="/garden/module/desert" className="garden-btn">了解详情</Link>
            </div>
          </div>

          <div className="garden-item"> {/* 第5项：标本馆 - 左文字，右图片 */}
            <div className="garden-content">
              <h2>标本馆</h2>
              <p>标本馆总建筑面积为4100平方米，建筑形象巧妙地融合其功能特点，其外观设计来源于厂房保护的岩石。内部重点打造"绿色星球奇幻之旅"植物主题大型沉浸式互动科普园和科普影院等科普宣传区，利用VR（虚拟现实）、AR（增强现实）、MR（混合现实）等感官体验技术，让游客从"一粒种子"开始，探索植物的奥秘。</p>
              <Link to="/garden/module/specimen" className="garden-btn">了解详情</Link>
            </div>
            <div className="garden-image">
              <img src={gardenImages.specimen} alt="标本馆" />
            </div>
          </div>

          <div className="garden-item "> {/* 第6项：室外专类园区 - 左图片，右文字 */}
            <div className="garden-image">
              <img src={gardenImages.outdoor} alt="室外专类园区" />
            </div>
            <div className="garden-content">
              <h2>室外专类园区</h2>
              <p>五个专类园区由杜鹃、百草、珍稀、山茶、和绿球园构成（其中杜鹃、绿球具花最多，花色丰富等特点，是春季的时令性植物；百草、山茶主要展现古中医药、茶树等，按植物"在地文化，保育研究特色植物种；珍稀园主要作为亚热带同地理条件植物的科普、保育直观室外专类园区地保护各类植物600余种。</p>
              <Link to="/garden/module/outdoor" className="garden-btn">了解详情</Link>
            </div>
          </div>
        </div>

        <div className="page-container">
          <div className="cta-section">
            <h2>欢迎前来参观</h2>
            <p>杏林花园全年开放，为确保最佳的参观体验，我们建议提前预约。团体参观可享受专业导览服务，深入了解植物知识和科研成果。</p>
          </div>
        </div>
    </div>
  );
}

export default Garden;